<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>
        <!-- Inicio Panel FILTRO -->
        <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
          <vs-card>
            <div slot="header">
              <h3 class="card-title mb-0">Información de filtro</h3>
            </div>
            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
            <vs-row>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <!-- Selector de empresa -->
                <company-selector v-model="companyId"/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de inicio</label>
                <vs-input type="date" v-model="initialDate" class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de fin</label>
                <vs-input type="date" v-model="finalDate" class="w-100 "/>
              </vs-col>
            </vs-row>
            <br/>
            <vs-row>
              <!-- Selector de tipo de servicio -->
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="thereStations">
                <label class="vs-input--label">Estación de pago</label>
                <multiselect v-model="selectedStations" placeholder="Seleccione una estación" label="name"
                             ref="myMultiselect" track-by="code" :options="showStations" :multiple="true"
                             :taggable="true" :searchable="false" :max-height="150" :max="50"  >
                </multiselect>
              </vs-col>
            </vs-row>
            <vs-row>
            </vs-row>
            <hr class="custom-hr"/>
            <div class="d-inline-block d-md-flex align-items-center">
              <div class="btn-alignment">
                <vs-button :disabled="!isSearch" @click="listPreview()">Buscar</vs-button>
                <vs-button color="gray" @click="clearForm()">Limpiar</vs-button>
              </div>
              <div class="ml-auto mt-3 mt-md-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                    <vs-button :disabled="!isDownloadable" class="btnx" type="filled" color="danger"
                               @click="downloadReport()">
                      <i class="ti-upload mr-2"></i>Exportar
                    </vs-button>

                    <vs-dropdown>
                      <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                      <vs-dropdown-menu>
                        <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                                   :value="document.id" :key="document.id"
                                   :id="document.id" @click="formatType=document.id">{{ document.name }}
                        </vs-button>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-col>
        <vs-col vs-lg="12" vs-xs="12" v-if="showTable">
          <vs-card>
            <h3 class="card-title d-flex">
              Tabla de previsualización
            </h3>
            <div class="border" style="max-height: 43em;
              overflow-y: auto;">
              <vs-table max-items="50" pagination :data="tableData">
                <template slot="thead">
                  <vs-th>Fecha de reporte</vs-th>
                  <vs-th>Estación o punto de pago</vs-th>
                  <vs-th>Rotación bicicleta</vs-th>
                  <vs-th>Tarjeta perdida</vs-th>
                  <vs-th>Mensual bicicleta</vs-th>
                  <vs-th>Casillero moto</vs-th>
                  <vs-th>Casillero bicicleta</vs-th>
                  <vs-th>Casillero men. moto</vs-th>
                  <vs-th>Casillero men. bicicleta</vs-th>
                  <vs-th>Qr perdido</vs-th>
                  <vs-th>Subtotal</vs-th>
                  <vs-th>Impuesto</vs-th>
                  <vs-th>Total recaudo</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr,indextr) in data">
                    <vs-td :data="data[indextr].days">
                      {{ data[indextr].days }}
                    </vs-td>
                    <vs-td :data="data[indextr].payPoint">
                      {{ data[indextr].payPoint }}
                    </vs-td>
                    <vs-td :data="data[indextr].parkBike">
                      {{ data[indextr].parkBike }}
                    </vs-td>
                    <vs-td :data="data[indextr].lostCard">
                      {{ data[indextr].lostCard }}
                    </vs-td>
                    <vs-td :data="data[indextr].monthlyBike">
                      {{ data[indextr].monthlyBike }}
                    </vs-td>
                    <vs-td :data="data[indextr].lockerMoto">
                      {{ data[indextr].lockerMoto }}
                    </vs-td>
                    <vs-td :data="data[indextr].lockerBike">
                      {{ data[indextr].lockerBike }}
                    </vs-td>
                    <vs-td :data="data[indextr].lockerMonthlyMoto">
                      {{ data[indextr].lockerMonthlyMoto }}
                    </vs-td>
                    <vs-td :data="data[indextr].lockerMonthlyBike">
                      {{ data[indextr].lockerMonthlyBike }}
                    </vs-td>
                    <vs-td :data="data[indextr].lostTicket">
                      {{ data[indextr].lostTicket }}
                    </vs-td>
                    <vs-td :data="data[indextr].subtotal">
                      {{ data[indextr].subtotal }}
                    </vs-td>
                    <vs-td :data="data[indextr].tax">
                      {{ data[indextr].tax }}
                    </vs-td>
                    <vs-td :data="data[indextr].totalBill">
                      {{ data[indextr].totalBill }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-card>
          <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
            <vs-card>
              <h3 class="card-title d-flex">
                Totales de la busqueda
              </h3>
              <div class="table-responsive border">
                <table class="table v-middle border">
                  <thead>
                  <tr>
                    <th class="border-top-0">
                      Rotación bicicleta
                    </th>
                    <th class="border-top-0">
                      Tarjeta perdida
                    </th>
                    <th class=" border-top-0">
                      Mensual bicicleta
                    </th>
                    <th class=" border-top-0">
                      Casillero moto
                    </th>
                    <th class=" border-top-0">
                      Casillero bicicleta
                    </th>
                    <th class=" border-top-0">
                      Casillero mensual moto
                    </th>
                    <th class="text-center border-top-0">
                      Casillero mensual bicicleta
                    </th>
                    <th class=" border-top-0">
                      Qr perdido
                    </th>
                    <th class=" border-top-0">
                      Subtotal
                    </th>
                    <th class=" border-top-0">
                      Impuesto IVA
                    </th>
                    <th class=" border-top-0">
                      Total facturación
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.parkBike) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.lostCard) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.monthlyBike) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.lockerMoto) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.lockerBike) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.lockerMonthlyMoto) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.lockerMonthlyBike) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.lostTicket) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.subtotal) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.tax) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ formatterCurrency(totalsPreview.totalBill) }}
                          </h5>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </vs-card>
          </vs-col>
          <!-- Fin de tabla de datos -->
        </vs-col>

      </vs-row>
    </vs-col>
  </vs-row>
</template>
<script>
import CompanySelector from "@/components/Shared/CompanySelector";
import DateUtils from "@/global/DateUtils";
import Multiselect from "vue-multiselect";
import centroMayorEndpoint from "@/endpoints/reports/centro-mayor/centroMayorEndpoint";
import {ROUTES} from "@/global/api_routes";
import toast from "@/global/ToastConfig";
import deviceEndpoint from "@/endpoints/machine/DeviceEndpoint";
import {formatPrice, formatPriceTwo} from "@/global/utils";

export default {
  name: 'Collection-mall',
  components: {
    CompanySelector,
    Multiselect,
  },
  data() {
    return {
      initialDate: null,
      finalDate: null,
      companyId: null,
      isLoading: false,
      documents: [
        {name: ".xlsx", id: "xlsx"},
      ],
      formatType: "xlsx",
      thereStations: false,
      selectedStations: [],
      showStations: [],
      listStations: [],
      tableData: [],
      showTable: false,
      totalsPreview: {},
      isSearch: false,
      isDownloadable: false,
      forceRender: 0,
    }
  },
  watch: {
    companyId() {
      this.showTable = false;
      this.showStations = [];
      this.tableData = [];
      this.selectedStations = [];
      this.validateStations();
      this.totalsPreview = {};
    },
    initialDate() {
      this.showTable = false;
      this.showStations = [];
      this.tableData = [];
      this.selectedStations = [];
      this.validateStations();
      this.totalsPreview = {};
    },
    finalDate() {
      this.showTable = false;
      this.showStations = [];
      this.tableData = [];
      this.selectedStations = [];
      this.validateStations();
      this.totalsPreview = {};
    },
    selectedStations() {
      this.tableData = [];
      this.totalsPreview = {};
      this.showTable = false;
    },
    showStations() {
      this.isSearch = false;
      this.isDownloadable = false;
      if (this.showStations.length > 0) {
        this.isSearch = true;
        this.isDownloadable = true;
      }

    }
  },
  methods: {
    /**
     * metodo que valida las fechas para traer la informacion de las estaciones
     * @returns {Promise<void>}
     */
    async validateStations() {
      if (!this.companyId) {
        this.thereStations = false;
        return;
      }
      if (!this.finalDate || !this.initialDate) {
        this.thereStations = false;
        return;
      }
      await this.listDevices();
      this.thereStations = true;

    },
    /**
     * metodo que limpia el formulario
     */
    clearForm() {
      this.companyId = null;
      this.thereStations = false;
      this.initialDate = null;
      this.finalDate = null;
      this.tableData = [];
      this.showTable = false;
      this.showStations = [];
      this.selectedStations = [];
      this.totalsPreview = {};
      this.isSearch = false;
      this.isDownloadable = false;

    },
    /**
     * metododo que le asigna el valor a los parametros para consultar y previsualizar la informacion
     * @returns {{finalDate: string, companyId: null, initialDate: string, payPoints: (*|string)}}
     */
    async prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({date: this.initialDate}),
        finalDate: DateUtils.toDateShortString({date: this.finalDate}),
        payPoints: await this.getValidateStations(),
      }
    },
    /**
     *  metodo que valida si seleccionaron una estacion o si no que tenga encuenta todas las estaciones
     * @returns {string}
     */
    async getValidateStations() {
      // se valida que si no seleccionan
      //estacion me las traiga todas
      console.log('validando estaciones');
      return this.selectedStations.length === 0
          ? this.showStations.map(item => item.code).join(",")
          : this.selectedStations.map(item => item.code).join(",")
    },
    /**
     * metodo que valida que los parametros del formulario inicial sean los correctos
     * @returns {Promise<void>}
     */
    async validateForm() {
      if (!this.companyId) {
        throw new Error("Seleccione una compañia");
      }
      if (!this.finalDate || !this.initialDate) {
        throw new Error("Debe seleccionar fecha inicial y/o fecha final");
      }
      const validationResult = await this.$validator.validateAll();
      const validateFinal = DateUtils.isValid(this.finalDate);
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (!validationResult) {
        throw new Error("Complete el formulario");
      }
      if (!validateFinal) {
        throw new Error("Debe seleccionar una fecha final igual o inferior a la actual");
      }
      if (validDates) {
        throw new Error("Fecha final no puede ser inferior a fecha inicial");
      }
    },
    /**
     * metodo de descrga del reporte
     * @returns {Promise<void>}
     */
    async downloadReport() {
      try {
        await this.validateForm();
        const objParams = await this.prepareParameters();
        this.isLoading = true;
        centroMayorEndpoint.downloadCollectionMall(objParams)
            .then(data => {
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              this.isLoading = false;
              let a = document.createElement("a");
              const urlFile =
                  process.env.VUE_APP_URL + ROUTES.GLOBAL.DOWNLOAD_FILE + data.info;
              a.href = urlFile;
              document.body.appendChild(a);
              console.log(urlFile);
              a.download = urlFile;
              a.click();
            })
      } catch (error) {
        toast.error(error);
      }
    },
    /**
     * metodo que genera la lista para previsualizar el la informacion
     * @returns {Promise<void>}
     */
    async listPreview() {
      try {
        await this.validateForm();
        this.isLoading = true;
        this.tableData = [];
        const objParams =  await this.prepareParameters();
        centroMayorEndpoint.listCollectionMall(objParams)
            .then(data => {
              if (data.info === null) {
                this.tableData = [];
                this.isLoading = false;
                return;
              }
              this.isLoading = false;
              this.tableData = data.info;
              this.showTable = true;
              this.getTableTotals(data.info);
            });
      } catch (error) {
        toast.error(error.message);
      }
    },
    /**
     * metodo que lista las estaciones que facturaron en el rango de fecha ingresado
     * @returns {Promise<void>}
     */
    async listDevices() {
      try {
        this.showStations = [];
        await this.validateForm();
        this.isLoading = true;
        const objParams =  await this.prepareParameters();
        deviceEndpoint.listByBillingRange(objParams)
            .then(data => {
              if (data.length === 0) {
                this.isLoading = false;
                return;
              }
              console.log(data);
              data.forEach((station) => {
                const unity = {
                  name: station.nickname,
                  code: station.code,
                };
                this.showStations.push(unity);
              });
            });
        this.isLoading = false;
        this.forceRender++;
      } catch (error) {
        toast.error(error.message);
      }
    },
    /**
     * formatea el valor
     * @param value
     * @returns {*}
     */
    formatterCurrency(value) {
      if (isNaN(parseFloat(value))) {
        return formatPriceTwo("0")
      }
      return formatPrice(value);
    },
    /**
     * metodo que quita de un string los signos y los puntos para ser operados matematicamente
     * @param value
     * @returns {*}
     */
    formatStringPrice(value) {
      value = value.replace(/[$.]/g, "").replace(",", ".");
      return value;
    },
    /**
     * metodo que suma los valores de la lista de previsualizacion
     * @param list
     */
    getTableTotals(list) {
      console.log(list, 'lista previ');
      const totals = {};
      list.forEach(value => {
        for (const property in value) {
          if (typeof totals[property] === 'undefined') {
            totals[property] = parseFloat(this.formatStringPrice(value[property])) || 0;
          } else {
            totals[property] += parseFloat(this.formatStringPrice(value[property])) || 0;
          }
        }
      });
      console.log('llegue a table totlas')
      this.prepareObjectTotals(totals)
    },
    prepareObjectTotals(obj) {
      // se eliminan propiedades innecesarias
      var deleteProperties = ["days", "payPoint"];
      for (var property in obj) {
        if (obj.hasOwnProperty(property) && deleteProperties.includes(property)) {
          delete obj[property];
        }
      }
      console.log(obj, 'este es el objeto de totales');
      this.totalsPreview = obj;
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>
